export default __webpack_public_path__ + "static/media/ShapeBox.cfb7f766.svg";